export default __webpack_public_path__ + "static/media/calconvert_background_l1.ec0b8e7b.jpg";